import React from 'react';

import { colours } from '$lib/tailwind/colours.js';
import tailwindConfig from '$root/tailwind.config.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const StyleGuidePage = () => {
    const typeStyles = Object.entries(tailwindConfig.theme.typeStyles({ theme: () => {} }));

    return (
        <main id='main-content'>
            <div className='layout-container layout-site-outer-padding'>
                <div className='flex flex-col gap-64'>
                    <div>
                        <h1>Style Guide</h1>
                        <hr />
                    </div>

                    <div>
                        <h2>Grid</h2>
                        <hr />

                        <div className='h-screen col-wrapper flex flex-wrap'>
                            {Array(12).fill(null).map((_itm, idx) => {
                                return (
                                    <div
                                        className='h-full w-1/12 col-padding'
                                        key={idx}>
                                        <div
                                            className='h-full'
                                            style={{ backgroundColor: '#e0e0e080' }} />
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div>
                        <h2>Typography</h2>
                        <hr />

                        <dl className='flex flex-col gap-16'>
                            {typeStyles.map((itm, idx) => {
                                return (
                                    <div key={idx}>
                                        <dd className={`type-style-${itm[0]}`}>The quick brown fox jumps over the lazy dog</dd>
                                        <dt>{itm[1].displayName}</dt>
                                    </div>
                                );
                            })}
                        </dl>
                    </div>

                    <div>
                        <h2>Colours</h2>
                        <hr />

                        <dl className='flex flex-col gap-32'>
                            {Object.entries(colours).map((group, idx) => {
                                // no need to render out other themes with same class names
                                if (idx > 1) { return; };

                                return (
                                    <div key={idx}>
                                        <h3>{group[0]}</h3>

                                        <dl className='flex flex-wrap'>
                                            {group[0] === 'swatch' ? (
                                                Object.entries(group[1]).map((item, jdx) => {
                                                    return (
                                                        <div
                                                            className='relative w-1/12 aspect-square'
                                                            key={jdx}>
                                                            <dd className='h-full w-full'>
                                                                <div className={`h-full w-full bg-${item[0]}`} />
                                                            </dd>
                                                            <dt>
                                                                <span
                                                                    className='absolute top-0 left-0 mix-blend-difference'
                                                                    style={{ filter: 'invert(1)' }}>
                                                                    {item[0]}
                                                                </span>
                                                            </dt>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                Object.keys(group[1]).map((key, kdx) => {
                                                    return (
                                                        <div
                                                            className='relative w-2/12 aspect-square'
                                                            key={kdx}>
                                                            <dd className='h-full w-full'>
                                                                <div className={`h-full w-full bg-${key}`} />
                                                            </dd>
                                                            <dt>
                                                                <span
                                                                    className='absolute top-0 left-0 mix-blend-difference'
                                                                    style={{ filter: 'invert(1)' }}>
                                                                    {key}
                                                                </span>
                                                            </dt>
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </dl>
                                    </div>
                                );
                            })}
                        </dl>
                    </div>
                </div>
            </div>

            {/* here so tailwind doesn't strip out dynamically used classes */}
            <div className='hide'>
                <span className='type-style-sans-display' />
                <span className='type-style-sans-h1' />
                <span className='type-style-sans-h2' />
                <span className='type-style-sans-h2-med' />
                <span className='type-style-sans-h3' />
                <span className='type-style-sans-h3-med' />
                <span className='type-style-sans-body' />
                <span className='type-style-sans-body-med' />
                <span className='type-style-sans-body-s' />
                <span className='type-style-serif-h2' />
                <span className='type-style-serif-h3' />
                <span className='type-style-serif-h4' />
                <span className='type-style-serif-body' />
                <span className='type-style-single-line-body' />
                <span className='type-style-single-line-eyebrow' />
                <span className='bg-neutral-950' />
                <span className='bg-pastel-red' />
                <span className='bg-pastel-blue' />
                <span className='bg-pastel-green' />
                <span className='bg-pastel-yellow' />
                <span className='bg-pastel-orange' />
                <span className='bg-neutral-900' />
                <span className='bg-neutral-800' />
                <span className='bg-neutral-700' />
                <span className='bg-neutral-600' />
                <span className='bg-neutral-500' />
                <span className='bg-neutral-400' />
                <span className='bg-neutral-300' />
                <span className='bg-neutral-200' />
                <span className='bg-neutral-100' />
                <span className='bg-neutral-50' />
                <span className='bg-neutral-25' />
                <span className='bg-neutral-00' />
                <span className='bg-secondary-yellow' />
                <span className='bg-secondary-blue' />
                <span className='bg-tint-light-0' />
                <span className='bg-tint-light-10' />
                <span className='bg-tint-light-20' />
                <span className='bg-tint-light-30' />
                <span className='bg-tint-light-40' />
                <span className='bg-tint-light-50' />
                <span className='bg-tint-light-60' />
                <span className='bg-tint-light-70' />
                <span className='bg-tint-light-80' />
                <span className='bg-tint-light-90' />
                <span className='bg-tint-dark-10' />
                <span className='bg-tint-dark-20' />
                <span className='bg-tint-dark-30' />
                <span className='bg-tint-dark-40' />
                <span className='bg-tint-dark-50' />
                <span className='bg-tint-dark-60' />
                <span className='bg-tint-dark-70' />
                <span className='bg-tint-dark-80' />
                <span className='bg-tint-dark-90' />
                <span className='bg-red-100' />
                <span className='bg-red-400' />
                <span className='bg-red-500' />
                <span className='bg-red-600' />
                <span className='bg-border-active' />
                <span className='bg-border-danger' />
                <span className='bg-border-danger-hover' />
                <span className='bg-border-default' />
                <span className='bg-button-primary-surface' />
                <span className='bg-button-primary-surface-hover' />
                <span className='bg-button-secondary-surface' />
                <span className='bg-button-secondary-surface-hover' />
                <span className='bg-button-tint-surface' />
                <span className='bg-button-tint-surface-hover' />
                <span className='bg-control-surface-hover' />
                <span className='bg-control-surface-selected' />
                <span className='bg-control-surface-unselected' />
                <span className='bg-icon-danger-default' />
                <span className='bg-icon-danger-secondary' />
                <span className='bg-icon-danger-tertiary' />
                <span className='bg-icon-default-invert' />
                <span className='bg-icon-default-primary' />
                <span className='bg-icon-default-secondary' />
                <span className='bg-icon-default-tertiary' />
                <span className='bg-surface-canvas' />
                <span className='bg-surface-danger' />
                <span className='bg-surface-emphasis' />
                <span className='bg-surface-panel-blue' />
                <span className='bg-surface-panel-green' />
                <span className='bg-surface-panel-neutral' />
                <span className='bg-surface-panel-orange' />
                <span className='bg-surface-panel-red' />
                <span className='bg-surface-panel-yellow' />
                <span className='bg-surface-raised' />
                <span className='bg-surface-raised-hover' />
                <span className='bg-surface-strong' />
                <span className='bg-text-danger-default' />
                <span className='bg-text-danger-secondary' />
                <span className='bg-text-danger-tertiary' />
                <span className='bg-text-default-invert' />
                <span className='bg-text-default-primary' />
                <span className='bg-text-default-secondary' />
            </div>
        </main>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default StyleGuidePage;
